// extracted by mini-css-extract-plugin
module.exports = {"container":"N_c","pages":"N_b8"};